var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureBlobStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61133 8.07422H22.3891V19.6584C22.3891 19.8426 22.316 20.0191 22.1858 20.1493C22.0556 20.2795 21.879 20.3527 21.6949 20.3527H2.30555C2.12143 20.3527 1.94485 20.2795 1.81466 20.1493C1.68447 20.0191 1.61133 19.8426 1.61133 19.6584V8.07422Z",
    fill: "url(#paint0_linear_33231_177194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30922 3.64747H21.6912C21.7824 3.64747 21.8727 3.66543 21.9569 3.70032C22.0411 3.7352 22.1176 3.78634 22.1821 3.8508C22.2466 3.91527 22.2977 3.9918 22.3326 4.07603C22.3675 4.16025 22.3854 4.25053 22.3854 4.34169V8.07436H1.61133V4.34169C1.61133 4.25022 1.6294 4.15964 1.66452 4.07518C1.69964 3.99071 1.7511 3.91402 1.81596 3.8495C1.88081 3.78499 1.95777 3.73393 2.04242 3.69926C2.12707 3.66459 2.21774 3.64699 2.30922 3.64747Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1766 9.61523H4.19159C4.00056 9.61523 3.8457 9.77009 3.8457 9.96112V13.4347C3.8457 13.6257 4.00056 13.7806 4.19159 13.7806H11.1766C11.3676 13.7806 11.5225 13.6257 11.5225 13.4347V9.96112C11.5225 9.77009 11.3676 9.61523 11.1766 9.61523Z",
    fill: "#0078D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.742 9.61523H12.757C12.566 9.61523 12.4111 9.77009 12.4111 9.96112V13.4347C12.4111 13.6257 12.566 13.7806 12.757 13.7806H19.742C19.933 13.7806 20.0879 13.6257 20.0879 13.4347V9.96112C20.0879 9.77009 19.933 9.61523 19.742 9.61523Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1375 14.6006H4.15253C3.9615 14.6006 3.80664 14.7554 3.80664 14.9465V18.42C3.80664 18.6111 3.9615 18.7659 4.15253 18.7659H11.1375C11.3286 18.7659 11.4834 18.6111 11.4834 18.42V14.9465C11.4834 14.7554 11.3286 14.6006 11.1375 14.6006Z",
    fill: "#0078D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.703 14.6006H12.718C12.5269 14.6006 12.3721 14.7554 12.3721 14.9465V18.42C12.3721 18.6111 12.5269 18.7659 12.718 18.7659H19.703C19.894 18.7659 20.0488 18.6111 20.0488 18.42V14.9465C20.0488 14.7554 19.894 14.6006 19.703 14.6006Z",
    fill: "#0078D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33231_177194",
    x1: 12.0002,
    y1: 20.3527,
    x2: 12.0002,
    y2: 8.07422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BEDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#32D4F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureBlobStorage);
export default __webpack_public_path__ + "static/media/AzureBlobStorage.b0662763032149a2a8c70a6b8aa49edd.svg";
export { ForwardRef as ReactComponent };